import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/exhaustMap';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/timeout';

export const GROWTH_IMPORT_STATUS = {pending: 'PENDING', running: 'RUNNING', succeeded: 'SUCCEEDED',
  partial: 'COMPLETED_WITH_GAPS', superseded: 'SUPERSEDED'};
export const GROWTH_IMPORT_FEEDBACK = {loading: 'GRADE_GROWTH_SOURCE_REFRESHING',
  partial: 'GRADE_GROWTH_SOURCE_REFRESH_PARTIAL', disabled: 'GRADE_GROWTH_SOURCE_REFRESH_DISABLED',
  denied: 'GRADE_GROWTH_SOURCE_REFRESH_DENIED', timeout: 'GRADE_GROWTH_SOURCE_REFRESH_TIMEOUT',
  failed: 'GRADE_GROWTH_SOURCE_REFRESH_FAILED', superseded: 'GRADE_GROWTH_SOURCE_REFRESH_SUPERSEDED'};
export const GROWTH_IMPORT_POLL_MS = 1500;
export const GROWTH_IMPORT_WAIT_MS = 120000;
const FIRST_POLL = 0;
const ONE_RESULT = 1;
const FORBIDDEN = 403;
const IMPORT_DISABLED = 'GROWTH_IMPORT_DISABLED';
const TIMEOUT = 'TimeoutError';
const INVALID_RESPONSE = 'Invalid growth import response';
const UUID = {bytes: 16, versionIndex: 6, variantIndex: 8, versionMask: 15, version: 64,
  variantMask: 63, variant: 128, radix: 16, width: -2, zero: '0', separator: '-', empty: '',
  first: 0, second: 4, third: 6, fourth: 8, fifth: 10};

export interface GrowthImportResponse {id: string; status: string; diagnostic?: string;}
export interface GrowthImportError {status?: number; name?: string; error?: {code?: string};}

export function refreshGrowthSource(http: HttpClient, base: string, requestId: string): Observable<GrowthImportResponse> {
  return http.post<GrowthImportResponse>(base + encodeURIComponent(requestId), null)
    .map(validateRun).switchMap(run => finished(run) ? Observable.of(run) : poll(http, base, run.id))
    .timeout(GROWTH_IMPORT_WAIT_MS);
}

function poll(http: HttpClient, base: string, id: string): Observable<GrowthImportResponse> {
  return Observable.timer(FIRST_POLL, GROWTH_IMPORT_POLL_MS)
    .exhaustMap(() => http.get<GrowthImportResponse>(base + encodeURIComponent(id)))
    .map(run => {
      if (validateRun(run).id !== id) { throw new Error(INVALID_RESPONSE); }
      return run;
    }).filter(finished).take(ONE_RESULT);
}

function validateRun(run: GrowthImportResponse): GrowthImportResponse {
  const statuses = GROWTH_IMPORT_STATUS;
  if (!run || !run.id || [statuses.pending, statuses.running, statuses.succeeded,
      statuses.partial, statuses.superseded].indexOf(run.status) < FIRST_POLL) {
    throw new Error(INVALID_RESPONSE);
  }
  return run;
}

function finished(run: GrowthImportResponse): boolean {
  return run.status !== GROWTH_IMPORT_STATUS.pending && run.status !== GROWTH_IMPORT_STATUS.running;
}

export function growthImportErrorKey(error: GrowthImportError): string {
  if (error && error.status === FORBIDDEN) { return GROWTH_IMPORT_FEEDBACK.denied; }
  if (error && error.error && error.error.code === IMPORT_DISABLED) { return GROWTH_IMPORT_FEEDBACK.disabled; }
  return error && error.name === TIMEOUT ? GROWTH_IMPORT_FEEDBACK.timeout : GROWTH_IMPORT_FEEDBACK.failed;
}

export function growthImportRequestId(random: Crypto): string {
  const bytes = new Uint8Array(UUID.bytes);
  random.getRandomValues(bytes);
  bytes[UUID.versionIndex] = bytes[UUID.versionIndex] & UUID.versionMask | UUID.version;
  bytes[UUID.variantIndex] = bytes[UUID.variantIndex] & UUID.variantMask | UUID.variant;
  const hex: string[] = [];
  for (let index = UUID.first; index < bytes.length; index++) {
    hex.push((UUID.zero + bytes[index].toString(UUID.radix)).slice(UUID.width));
  }
  return [hex.slice(UUID.first, UUID.second), hex.slice(UUID.second, UUID.third),
    hex.slice(UUID.third, UUID.fourth), hex.slice(UUID.fourth, UUID.fifth), hex.slice(UUID.fifth)]
    .map(part => part.join(UUID.empty)).join(UUID.separator);
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/grade-growth/grade-growth-source-refresh.ts